import axios from 'axios';
import { Api } from 'application/interfaces/api';
import {
  SendEmailInput,
  SendEmailOutput,
} from 'application/interfaces/models/emailingService';
import { AppError } from 'application/entities/app-error';

const emailingService: Api['emailingService'] = {
  sendEmail: async (payload: SendEmailInput): Promise<SendEmailOutput> => {
    const { GATSBY_SHIPA_API_BASE } = process.env;

    if (!GATSBY_SHIPA_API_BASE) {
      throw new AppError(
        'internalError',
        'GATSBY_SHIPA_API_BASE env variable is empty',
      );
    }

    try {
      const res = await axios.post<boolean>(
        `${ GATSBY_SHIPA_API_BASE }/send-email`,
        payload,
      );

      return res?.data;
    } catch (error) {
      if (
        error?.response?.data
        && error?.response?.status >= 400
        && error?.response?.status < 500
      ) {
        throw new AppError(
          'internalError',
          JSON.stringify(error.response.data),
        );
      }

      throw new AppError(
        'serverError',
        'Server error. Please contact administrator.',
      );
    }
  },
};

export default emailingService;
